// components/AdSenseAutoAds.js
// Re-triggers AdSense auto-ads on every client-side route change (React SPA fix)
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function AdSenseAutoAds() {
  const location = useLocation();

  useEffect(() => {
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({
        google_ad_client: 'ca-pub-5038270250663768',
        enable_page_level_ads: true,
      });
    } catch (_) {}
  }, [location.pathname]);

  return null;
}
